import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { CalcMedicineDurationCost } from 'src/requests/DecisionMedicine'

export const useCalcCost = (dataItem: any, decisionId: number | null, hospitalId: number | null) => {

    const [data, setData] = useState<any>(null)
    const [loading, setLoading] = useState(false)

    const { state } = useLocation()

    useEffect(() => {
        //@ts-ignore
        if (!Object.entries(dataItem)?.map(([key, value]) => value).some((v: any) => !!v) || !dataItem?.sMedicine) return;
        const timeout = setTimeout(() => {
            const reqData = {
                medicineId: dataItem?.sMedicine?.value || null,
                allowsAllDurations: dataItem?.allowsAllDurations || null,
                duration: dataItem?.duration || null,
                decisionId: decisionId || null,
                durationType: dataItem?.durationType?.value || null,
                directAmount: dataItem?.directAmount || null,
                doseTypeId: dataItem?.sDoseType?.value || null,
                dosePerDay: dataItem?.dosePerDay || null,
                doseCountPerTime: dataItem?.doseCountPerTime || null,

            }

            setLoading(true)
            CalcMedicineDurationCost(reqData, state?.pharmName?.value, hospitalId).then((res) => {
                setData(res.data.data)
                setLoading(false)
            }).catch(() => setLoading(false))
        }, 200);
        return () => clearTimeout(timeout);

    }, [dataItem])


    return { data, loading }
}
